import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { loadScript } from "../../../../../globals/constants";
import JobZImage from "../../../../common/jobz-img";
import SectionJobLocation from "../../sections/jobs/detail/section-job-location";
import SectionOfficePhotos1 from "../../sections/common/section-office-photos1";
import SectionOfficeVideo1 from "../../sections/common/section-office-video1";
import SectionShareProfile from "../../sections/common/section-share-profile";
import SectionJobsSidebar2 from "../../sections/jobs/sidebar/section-jobs-sidebar2";
import { jobService } from "../../../../../services/job-service";
import { useAuth } from "../../../../../context/AuthContext";

function JobDetail1Page() {
    const { id = "job_1" } = useParams();
    const actualJobId = id.includes("-") ? id.split("-").pop() : id;
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [job, setJob] = useState(null);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const sidebarConfig = {
        showJobInfo: true
    }

    useEffect(() => {
        loadScript("js/custom.js");
    });

    useEffect(() => {
        setLoading(true);
        const previewMode = new URLSearchParams(location.search).get("preview") === "1";
        const loader = previewMode ? jobService.preview(actualJobId) : jobService.get(actualJobId);
        loader
            .then((data) => setJob(data.job))
            .catch((error) => setMessage(error.message))
            .finally(() => setLoading(false));
    }, [actualJobId, location.search]);

    const apply = async () => {
        if (!user) {
            navigate("/login");
            return;
        }
        if (user.role !== "candidate") {
            setMessage("Please use a candidate account to apply for jobs.");
            return;
        }
        try {
            const data = await jobService.apply(job.id, "");
            setMessage(data.message || "Application submitted.");
        } catch (error) {
            setMessage(error.message);
        }
    };

    if (loading) return <div className="p-a50 text-center">Loading job...</div>;
    if (!job) return <div className="p-a50 text-center">{message || "Job not found."}</div>;
    const locked = Boolean(job.locked_details);

    return (
        <>
            <div className="section-full  p-t120 p-b90 bg-white">
                <div className="container">
                    <div className="section-content">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 col-md-12">
                                <div className="cabdidate-de-info">
                                    {message && <div className="alert alert-info">{message}</div>}
                                    {job.status !== "published" && <div className="alert alert-warning">Draft preview: this job is not live publicly until admin approval.</div>}
                                    <div className="twm-job-self-wrap">
                                        <div className="twm-job-self-info">
                                            <div className="twm-job-self-top">
                                                <div className="twm-media-bg">
                                                    <JobZImage src={job.job_poster_url || job.company_banner_url || job.job_image_url || "images/job-detail-bg.jpg"} alt={job.title} />
                                                    <div className="twm-jobs-category green"><span className="twm-bg-green">{job.job_type}</span></div>
                                                </div>
                                                <div className="twm-mid-content">
                                                    <div className="twm-media">
                                                        <JobZImage src={job.company_logo_url || job.job_image_url || "images/jobs-company/pic1.jpg"} alt={job.company_name || job.title} />
                                                    </div>
                                                    <h4 className="twm-job-title">{job.title} <span className="twm-job-post-duration">/ {formatDate(job.created_at)}</span></h4>
                                                    <p className="twm-job-address"><i className="feather-map-pin" />{locked ? "Login to view job location" : job.location}</p>
                                                    {!locked ? <div className="twm-job-self-mid">
                                                        <div className="twm-job-self-mid-left">
                                                            <Link to={job.company_id ? `/emp-detail/${job.company_id}` : "#"} className="twm-job-websites site-text-primary">{job.company_name || "Company"}</Link>
                                                            <div className="twm-jobs-amount">{salary(job)} <span>/ {job.salary_period || "Month"}</span></div>
                                                        </div>
                                                        <div className="twm-job-apllication-area">Application ends:
                                                            <span className="twm-job-apllication-date">{job.expires_at || "Open"}</span>
                                                        </div>
                                                    </div> : <LockedNotice />}
                                                    <div className="twm-job-self-bottom">
                                                        {locked ? (
                                                            <button className="site-button" type="button" onClick={() => navigate("/login")}>Login / Sign up to Apply</button>
                                                        ) : (
                                                            <button className="site-button" type="button" onClick={apply} disabled={job.status !== "published"}>
                                                                Apply Now
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 className="twm-s-title">Job Description:</h4>
                                    <p>{job.description}</p>
                                    {locked ? (
                                        <div className="alert alert-warning">
                                            <strong><i className="fa fa-lock" /> Full job details are locked.</strong>
                                            <div>Login or create a free candidate account to view requirements, salary, location, company contact details, and apply options.</div>
                                            <button className="site-button m-t15" type="button" onClick={() => navigate("/login")}>Login / Sign up</button>
                                        </div>
                                    ) : (
                                        <>
                                            <h4 className="twm-s-title">Requirements:</h4>
                                            <ul className="description-list-2">
                                                <li><i className="feather-check" />Experience: {job.experience || "Relevant experience preferred."}</li>
                                                <li><i className="feather-check" />Qualification: {job.qualification || "As per company requirements."}</li>
                                                <li><i className="feather-check" />Workplace: {job.workplace_type}</li>
                                            </ul>
                                        </>
                                    )}

                                    <SectionShareProfile />
                                    <SectionJobLocation />

                                    <div className="twm-two-part-section">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-12">
                                                <SectionOfficePhotos1 />
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <SectionOfficeVideo1 />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 rightSidebar">
                                <SectionJobsSidebar2 _config={sidebarConfig} job={job} locked={locked} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function LockedNotice() {
    return (
        <div className="alert alert-warning m-t15">
            <i className="fa fa-lock" /> Login required to view salary, location, expiry, requirements, and contact details.
        </div>
    );
}

function salary(job) {
    if (job.salary_min && job.salary_max) return `${formatInr(job.salary_min)} - ${formatInr(job.salary_max)}`;
    if (job.salary_min) return formatInr(job.salary_min);
    return "Salary disclosed";
}

function formatInr(value) {
    return `₹${Number(value || 0).toLocaleString("en-IN")}`;
}

function formatDate(value) {
    if (!value) return "Recently";
    return new Date(value).toLocaleDateString();
}

export default JobDetail1Page;
